import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { shareWithStudentsRequest } from './request.share-with-students.js';

function useShareWithStudentsMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(shareWithStudentsMutation(client, notifier, user));
}
const shareWithStudentsMutation = (client, notifier, user) => {
  return {
    mutationKey: ["course-builder/sync", user?.id],
    mutationFn: input => {
      if (!user || !user.institution?.id) {
        throw new Error("Cannot share if no user is available");
      }
      return shareWithStudentsRequest(user.institution?.id, input.course.id, input.studentIds);
    },
    onSuccess: () => {
      notifier.notify({
        id: "course-builder.share-with-students",
        type: "success",
        body: "Forløbet er blevet delt."
      });
    },
    onError: () => {
      notifier.notify({
        id: "course-builder.share-with-students.error",
        type: "error",
        body: "Forløbet kunne ikke deles. Prøv igen om lidt."
      });
    }
  };
};

export { useShareWithStudentsMutation };
//# sourceMappingURL=mutation.share-with-students.js.map
